import Vue from "vue";

const pages = Object.freeze({
    CHALLENGES: 'challenges',
    PROGRAMS: 'programs',
    DISCOVER: 'discover',
    LEADERBOARD: 'leaderboard',
    PROGRESS: 'progress',
    SMB_USERS_SECTION: 'smb_users_section',
    SMB_USERS: 'smb_users',
    SMB_TEAMS: 'smb_teams',
    SMB_REPORT: "smb_report",
    AI_REPORT : 'ai_report',
    SMB_CHALLENGES: "smb_challenges",
    SMB_PROGRAMS: "smb_programs",
    SMB_SIGN_UP: "smb_sign_up",
    SMB_SIGN_IN: "smb_sign_in",
    Achievements: "achievements",
    Assessment: 'assessment'
});
const defaultTheme = {
    [pages.CHALLENGES]: {
        name: "Challenge",
        show: true,
    },
    [pages.PROGRAMS]: {
        name: "Program",
        show: true,
    },
    [pages.LEADERBOARD]: {
        name: "Leaderboard",
        show: true,
    },
    [pages.PROGRESS]: {
        name: "Progress",
        show: true
    },
    [pages.Achievements]: {
        name: "Achievement"
    },
    [pages.Assessment]: {
        name: "Assessment",
    },
    [pages.SMB_USERS_SECTION]: {
        name: "User <br> Management"
    },
    [pages.SMB_USERS]: {
        name: "User"
    },
    [pages.SMB_TEAMS]: {
        name: "Team"
    },
    [pages.SMB_REPORT]: {
        name: "Report"
    },
    [pages.AI_REPORT] : {
        name: "AI Report"
    },
    [pages.SMB_CHALLENGES]: {
        name: "Challenge"
    },
    [pages.SMB_PROGRAMS]: {
        name: "Program"
    },
    [pages.SMB_SIGN_UP]: {
        img: require("@/assets/images/SMB/signup-smb.png")
    },
    [pages.SMB_SIGN_IN]: {
        img: require("@/assets/images/SMB/login-smb.png")
    },
};
function createTheme(changes) {
    let newTheme = Object.assign({}, defaultTheme);
    if (changes && Object.keys(changes).length) {
        Object.keys(changes).forEach(key => {
            if (key in defaultTheme)
                newTheme[key] = Object.assign({}, newTheme[key], changes[key]);
        })
    }
    return newTheme;
}
const types = Object.freeze({
    DEFAULT: '',
    PHYSIOTHERAPY: 'physiotherapy',
});
const themes = {
    [types.DEFAULT]: createTheme(),
    [types.PHYSIOTHERAPY]: createTheme({
        [pages.CHALLENGES]: {
            name: "Group Plan"
        },
        [pages.PROGRAMS]: {
            name: "Treatment Plan"
        },
        [pages.LEADERBOARD]: {
            show: false
        },
        [pages.SMB_USERS_SECTION]: {
            name: "Patient <br> Management"
        },
        [pages.SMB_USERS]: {
            name: "Patient"
        },
        [pages.SMB_TEAMS]: {
            name: "Team"
        },
        [pages.SMB_REPORT]: {
            name: "Patient Report"
        },
        [pages.AI_REPORT] : {
            name: "AI Report"
        },
        [pages.SMB_CHALLENGES]: {
            name: "Group Plan"
        },
        [pages.SMB_PROGRAMS]: {
            name: "Treatment Plan"
        },
        [pages.SMB_SIGN_UP]: {
            img: require("@/assets/images/SMB/physiotherapy_sign_up.png")
        },
        [pages.SMB_SIGN_IN]: {
            img: require("@/assets/images/SMB/physiotherapy_sign_in.png")
        }
    })
};

const getState = () => {
    return {
        types,
        pages,
        activeThemeType: types.DEFAULT,
        ...createTheme()
    };
}
const state = getState();

const mutations = {
    setTheme(state, type) {
        if (type && Object.values(types).includes(type)) {
            state.activeThemeType = type;
            const theme = createTheme(themes[state.activeThemeType]);
            Object.keys(theme).forEach(key => Vue.set(state, key, theme[key]));
        }
    }
};

const getters = {
    theme(state) {
        return state;
    },
    pages(state) {
        return pages;
    },
    themes(state) {
        return types;
    },
    activeTheme(state) {
        return state.activeThemeType;
    }
};

const actions = {
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
